export default {
  title: "Mjölnerbacken 76",
  home: "Hem",
  locale: {
    english: "Engelska",
    swedish: "Svenska",
  },
  shopping: {
    title: "Shopping",
  },
  departures: {
    title: "Avgångar",
    platform: "Plattform",
    position: "Läge",
    closeByStations: "Nära",
    stopDeviations: "Avvikelser",
  },
  schoolLunch: {
    title: "Skollunch",
    previousWeek: "Föregående vecka",
    weekNumber: "Vecka %WEEK%",
    now: "Denna vecka (%WEEK%)",
    nextWeek: "Nästa vecka",
    noLunch: "Inga lunchmenyer hittades",
  },
  takk: {
    title: "Takk",
  },
  weeklyDinner: {
    title: "Veckans middag",
  },
  login: {
    title: "Logga in",
    email: "E-postadress",
    password: "lösenord",
    submit: "Logga in",
  },
  logout: "Logga ut",
  send: {
    title: "Skicka",
    submit: "Skicka",
  },
  profile: {
    title: "Profil",
    email: "E-postadress",
    currentPassword: "Nuvarande lösenord",
    updatePassword: "Uppdatera lösenord",
    password: "Lösenord",
    repeatPassword: "Upprepa lösenord",
    submit: "Uppdatera",
    sender: "Avsändare",
    incorrectOldPassword: "Felaktigt nuvarande lösenord",
  },
  weekdays: {
    monday: "Måndag",
    tuesday: "Tisdag",
    wednesday: "Onsdag",
    thursday: "Torsdag",
    friday: "Fredag",
    saturday: "Lördag",
    sunday: "Söndag",
  },
};
